<template>
    <div class="modal modal-create-profil">
        <div class="wrapper">
            <div class="modal__header">
                <IconSpeaker class="speaker" @click="speechSynthesis(text)"></IconSpeaker>
                <p>{{ text }}</p>
            </div>
            <div class="modal__body">
                <p>Załóż profil dla swojego dziecka, dzięki temu bęziesz mógł polecać mu najciekawsze treści z Krainy ABC</p>
            </div>
            <div class="modal__button">
                <button class="btn-cancel" @click="closeHandle">
                    <span>Anuluj</span>
                </button>
                <button class="btn-success" @click="createProfile">
                    <span>Załóż profil</span>
                </button>
            </div>
            <IconClose class="close" @click="closeHandle"></IconClose>

        </div>
    </div>
</template>

<script>
import IconClose from "../elements/icons/IconClose.vue";
import IconSpeaker from "../elements/icons/IconSpeaker.vue";

    export default {
        name: 'ModalCreateProfil',
        components: {
            IconClose,
            IconSpeaker,
        },
        data() {
            return {
                showModalTime: false,
                showModalInfo: true,
                text: 'Załóż profil dla swojego dziecka',
            }
        },
        methods: {
            createProfile() {
                this.$router.push({
                    path: 'dodaj-profil'
                });  
                this.closeHandle();
            },
            closeHandle() {
                this.$store.dispatch("changeModalCreateProfilState");
                this.$store.dispatch("changeModalBackdrop", false);
            },
        },
    }
</script>